import { gql } from '@/__generated__';

const UPDATE_USER_PREFERENCES_INTERFACE = gql(`#graphql
  mutation UpdateUserPreferencesInterface($input: UpdateUserPreferencesInterfaceInput!) {
    updateUserPreferencesInterface(input: $input) {
      id
      defaultIndexRoute
      controlCenterVersion
      reportsVersion
      homeAmaruFavoriteView
    }
  }
`);

export default UPDATE_USER_PREFERENCES_INTERFACE;
